export enum PrescriptionSourceTypeEnum {
  details = 0,
  files,
}
